var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAdvancedSettings = function SvgIconAdvancedSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_advanced_settings_svg2__a",
    x1: 26.22,
    x2: 366.42,
    y1: 455.3,
    y2: 85.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__b",
    x1: 149.01,
    x2: 489.21,
    y1: 568.33,
    y2: 198.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__c",
    x1: -115.21,
    x2: 224.98,
    y1: 325.1,
    y2: -44.46
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__d",
    x1: -112,
    x2: 228.2,
    y1: 328.06,
    y2: -41.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__e",
    x1: -52.93,
    x2: 287.27,
    y1: 382.43,
    y2: 12.88
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__f",
    x1: -49.71,
    x2: 290.49,
    y1: 385.4,
    y2: 15.84
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__g",
    x1: 9.36,
    x2: 349.55,
    y1: 439.77,
    y2: 70.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__h",
    x1: 12.55,
    x2: 352.74,
    y1: 442.71,
    y2: 73.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__i",
    x1: -13.08,
    x2: 327.11,
    y1: 419.12,
    y2: 49.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__j",
    x1: -48.16,
    x2: 292.03,
    y1: 386.82,
    y2: 17.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__k",
    x1: -66.6,
    x2: 273.6,
    y1: 369.85,
    y2: 0.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__l",
    x1: 15.99,
    x2: 356.18,
    y1: 445.87,
    y2: 76.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__m",
    x1: 10.72,
    x2: 350.91,
    y1: 441.03,
    y2: 71.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_advanced_settings_svg2__a",
    id: "icon_advanced_settings_svg2__n",
    x1: 21.33,
    x2: 361.52,
    y1: 450.79,
    y2: 81.24
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m492.5 322.96-12.92-8.54-12.79-30.88 3.1-15.19c1.12-5.48-.58-11.17-4.54-15.12l-18.58-18.58a16.66 16.66 0 0 0-15.12-4.53l-15.18 3.11-30.89-12.8-8.55-12.92c-3.08-4.68-8.3-7.49-13.9-7.5h-4.8V91.68c0-.18-.09-.33-.1-.52a8.3 8.3 0 0 0-.45-2.2c-.09-.27-.16-.53-.28-.78-.39-.88-.94-1.68-1.61-2.38L272.57 2.46c-.7-.68-1.52-1.23-2.41-1.62-.25-.11-.5-.2-.75-.28-.73-.26-1.49-.41-2.27-.45-.16-.04-.31-.08-.47-.11H25C11.19 0 0 11.19 0 25v391.67c0 13.81 11.19 25 25 25h206.29c.78 1.9 1.91 3.63 3.33 5.12l18.56 18.56c3.95 3.97 9.64 5.68 15.13 4.55l15.19-3.11 30.91 12.8 8.55 12.92c3.08 4.68 8.3 7.49 13.9 7.5h26.27c5.6 0 10.83-2.82 13.91-7.5l8.54-12.92 30.89-12.8 15.18 3.11c5.48 1.12 11.17-.58 15.12-4.54l18.57-18.57c3.96-3.96 5.66-9.64 4.54-15.12l-3.1-15.19 12.79-30.88 12.92-8.55c4.68-3.08 7.49-8.3 7.5-13.9v-26.27c0-5.6-2.82-10.83-7.5-13.91ZM275 28.45l54.88 54.88h-46.55A8.33 8.33 0 0 1 275 75zM231.47 425H25a8.33 8.33 0 0 1-8.33-8.33V25c0-4.6 3.73-8.33 8.33-8.33h233.33V75c0 13.81 11.19 25 25 25h58.33v100h-4.8c-5.6 0-10.83 2.82-13.91 7.5l-8.54 12.92-30.88 12.8-15.2-3.11c-5.49-1.14-11.18.57-15.12 4.54l-18.56 18.56a16.68 16.68 0 0 0-4.55 15.13l3.11 15.19-12.79 30.88-12.92 8.55c-4.68 3.08-7.49 8.3-7.5 13.9v26.27c0 5.6 2.82 10.83 7.5 13.91l12.92 8.54 12.8 30.88-1.74 8.53Zm236.79-51.92a8.34 8.34 0 0 0-3.11 3.76l-14.74 35.61a8.34 8.34 0 0 0-.47 4.86l3.62 17.69-18.57 18.57-17.68-3.62a8.26 8.26 0 0 0-4.86.46l-35.61 14.75a8.34 8.34 0 0 0-3.76 3.11l-9.96 15.07h-26.27l-9.95-15.07a8.34 8.34 0 0 0-3.76-3.11l-35.61-14.75a8.3 8.3 0 0 0-3.18-.63c-.56 0-1.12.06-1.67.17l-17.69 3.62L246.41 435l3.62-17.69c.33-1.63.18-3.32-.46-4.86l-14.75-35.61a8.34 8.34 0 0 0-3.11-3.76l-15.07-9.95v-26.27l15.07-9.95a8.34 8.34 0 0 0 3.11-3.76l14.75-35.61c.63-1.54.79-3.23.46-4.86l-3.62-17.69 18.57-18.57 17.69 3.62c1.63.34 3.32.18 4.86-.46l35.61-14.75a8.34 8.34 0 0 0 3.76-3.11l9.95-15.07h26.27l9.95 15.07a8.34 8.34 0 0 0 3.76 3.11l35.61 14.75c1.54.64 3.23.8 4.86.46l17.69-3.62 18.57 18.57-3.62 17.69a8.34 8.34 0 0 0 .47 4.86l14.74 35.61a8.34 8.34 0 0 0 3.11 3.76l15.07 9.95v26.27z",
    style: {
      fill: "url(#icon_advanced_settings_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 258.33c-50.63 0-91.67 41.04-91.67 91.67s41.04 91.67 91.67 91.67 91.67-41.04 91.67-91.67c-.06-50.6-41.07-91.61-91.67-91.67M350 425c-41.42 0-75-33.58-75-75s33.58-75 75-75 75 33.58 75 75c-.05 41.4-33.6 74.95-75 75",
    style: {
      fill: "url(#icon_advanced_settings_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 150H125c13.81 0 25-11.19 25-25v-8.5a8.33 8.33 0 0 0-16.66 0v8.5c0 4.6-3.73 8.33-8.33 8.33H66.68a8.33 8.33 0 0 1-8.33-8.33V66.67c0-4.6 3.73-8.33 8.33-8.33h50.17a8.33 8.33 0 0 0 0-16.66H66.68c-13.81 0-25 11.19-25 25v58.33c0 13.81 11.19 25 25 25Z",
    style: {
      fill: "url(#icon_advanced_settings_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.23 50.26c-2.89-.98-6.09-.3-8.33 1.77v-.02l-52.49 45L89.2 85.8a8.333 8.333 0 0 0-11.68.1 8.333 8.333 0 0 0-.1 11.68l16.67 16.67a8.33 8.33 0 0 0 11.32.43l58.33-50a8.35 8.35 0 0 0 3.03-7.96 8.34 8.34 0 0 0-5.54-6.47Z",
    style: {
      fill: "url(#icon_advanced_settings_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.67 275H125c13.81 0 25-11.19 25-25v-8.5a8.33 8.33 0 0 0-16.66 0v8.5c0 4.6-3.73 8.33-8.33 8.33H66.68a8.33 8.33 0 0 1-8.33-8.33v-58.33c0-4.6 3.73-8.33 8.33-8.33h50.17a8.33 8.33 0 0 0 0-16.66H66.68c-13.81 0-25 11.19-25 25v58.33c0 13.81 11.19 25 25 25Z",
    style: {
      fill: "url(#icon_advanced_settings_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.23 175.26c-2.89-.98-6.09-.3-8.33 1.77V177l-52.49 45-11.21-11.21a8.333 8.333 0 0 0-11.68.1 8.333 8.333 0 0 0-.1 11.68l16.67 16.67a8.33 8.33 0 0 0 11.32.43l58.33-50a8.35 8.35 0 0 0 3.03-7.96 8.34 8.34 0 0 0-5.54-6.47Z",
    style: {
      fill: "url(#icon_advanced_settings_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.67 358.17a8.33 8.33 0 0 0-8.33 8.33v8.5c0 4.6-3.73 8.33-8.33 8.33H66.68a8.33 8.33 0 0 1-8.33-8.33v-58.33c0-4.6 3.73-8.33 8.33-8.33h50.17a8.33 8.33 0 0 0 0-16.66H66.68c-13.81 0-25 11.19-25 25v58.33c0 13.81 11.19 25 25 25h58.33c13.81 0 25-11.19 25-25v-8.5c0-4.6-3.73-8.33-8.33-8.33Z",
    style: {
      fill: "url(#icon_advanced_settings_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.9 302.04v-.03l-52.49 45L89.2 335.8a8.333 8.333 0 0 0-11.68.1 8.333 8.333 0 0 0-.1 11.68l16.67 16.67a8.33 8.33 0 0 0 11.32.43l58.33-50a8.327 8.327 0 0 0 .67-11.54c-2.91-3.4-8-3.89-11.51-1.11Z",
    style: {
      fill: "url(#icon_advanced_settings_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67 141.67h116.67a8.33 8.33 0 0 0 0-16.66H191.67a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#icon_advanced_settings_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67 108.33h48.42a8.33 8.33 0 0 0 0-16.66h-48.42a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#icon_advanced_settings_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67 75h41.67a8.33 8.33 0 0 0 0-16.66h-41.67a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#icon_advanced_settings_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67 200h116.67a8.33 8.33 0 0 0 0-16.66H191.67a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#icon_advanced_settings_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67 233.33h35.83a8.33 8.33 0 0 0 0-16.66h-35.83a8.33 8.33 0 0 0 0 16.66",
    style: {
      fill: "url(#icon_advanced_settings_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67 258.33c0-4.6-3.73-8.33-8.33-8.33h-13.67a8.33 8.33 0 0 0 0 16.66h13.67c4.6 0 8.33-3.73 8.33-8.33",
    style: {
      fill: "url(#icon_advanced_settings_svg2__n)"
    }
  }));
};
export default SvgIconAdvancedSettings;